/** Formats a PascalCase relation type from the API for display, e.g. "PrimaryWeapon" → "Primary Weapon"; former relations get an "Ex-" prefix. */
export const formatRelationType = (relationType: string, isEx?: boolean): string => {
	const label = relationType.replace(/([a-z])([A-Z])/g, "$1 $2");

	return isEx ? `Ex-${label}` : label;
};
